<div class="flex">
  <app-button
    #trigger
    type="cancel"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen()"
    [icon]="triggerIconClass() ?? undefined"
    [label]="triggerLabel()"
    [isForDropdown]="true"
    [active]="isOpen()"
    [disabled]="disabled()"
    (clickEvent)="toggle()" />

  <app-dropdown
    [target]="trigger.elementRef.nativeElement"
    [template]="dropdownContent"
    [isOpen]="isOpen()"
    [onClose]="close"
    [closeOnClickOutside]="true"
    [closeOnEscape]="true" />
</div>

<ng-template #dropdownContent>
  <div class="w-72" role="listbox" [attr.aria-multiselectable]="multiple()">
    @if (enableSearch()) {
      <div class="mb-1 flex w-full items-center gap-2">
        <input
          type="text"
          class="focus:border-accent-focus focus:ring-accent-focus border-default placeholder:text-text-tertiary hover:border-strong h-7 w-full rounded-sm border px-3 py-1 text-sm focus:ring-2 focus:outline-none"
          [value]="searchTerm()"
          (input)="onSearchInput($event)"
          [placeholder]="searchPlaceholder()" />
      </div>
    }
    <div class="max-h-64 overflow-y-auto" (scroll)="onListScroll($event)">
      @for (item of items(); track item.id) {
        @if (multiple()) {
          <div
            class="flex items-center gap-2.25 rounded-sm px-2 py-1.5 text-[13px] leading-snug font-medium whitespace-nowrap transition-colors"
            [class]="
              item.disabled
                ? 'text-text-tertiary cursor-not-allowed'
                : 'text-text-primary hover:bg-interactive cursor-pointer'
            "
            (click)="onItemClick(item)"
            (keydown.enter)="onItemClick(item)"
            role="option"
            [attr.aria-selected]="isItemSelected(item)"
            [attr.aria-disabled]="item.disabled || null">
            <span
              class="flex h-3.75 w-3.75 shrink-0 items-center justify-center rounded-[3px] border-[1.5px] transition-colors"
              [class]="
                isItemSelected(item)
                  ? 'bg-accent-main border-accent-main text-white'
                  : 'border-strong bg-elevated text-transparent'
              ">
              <i class="ph-bold ph-check text-[10px] leading-none"></i>
            </span>
            <span class="min-w-0 flex-1 overflow-hidden text-ellipsis">{{
              item.label
            }}</span>
          </div>
        } @else {
          <div
            class="flex items-center gap-2.25 rounded-sm px-2 py-1.5 text-[13px] leading-snug font-medium whitespace-nowrap transition-colors"
            [class]="
              item.disabled
                ? 'text-text-tertiary cursor-not-allowed'
                : isItemSelected(item)
                  ? 'bg-accent-interactive text-accent-main hover:bg-accent-interactive-hover cursor-pointer'
                  : 'text-text-primary hover:bg-interactive cursor-pointer'
            "
            (click)="onItemClick(item)"
            (keydown.enter)="onItemClick(item)"
            role="option"
            [attr.aria-selected]="isItemSelected(item)"
            [attr.aria-disabled]="item.disabled || null">
            <span
              class="flex w-4 shrink-0 items-center justify-center text-sm leading-none"
              [class]="isItemSelected(item) ? 'text-accent-main' : 'invisible'">
              <i class="ph-bold ph-check"></i>
            </span>
            <span class="min-w-0 flex-1 overflow-hidden text-ellipsis">{{
              item.label
            }}</span>
          </div>
        }
      } @empty {
        <p class="text-text-tertiary px-3 py-2 text-sm">{{ emptyMessage() }}</p>
      }
    </div>
  </div>
</ng-template>
